module.exports = __webpack_public_path__ + "img/nav-header-mobile-jewelry@2x.6ceb79a.jpg";